export const batchStatusMap = {
  '-3': { label: 'Timeout', variant: 'error' },
  '-2': { label: 'Cancelled', variant: 'warning' },
  '-1': { label: 'Failed', variant: 'error' },
  0: { label: 'Pending', variant: 'neutral' },
  1: { label: 'Running', variant: 'info' },
  2: { label: 'Completed', variant: 'success' }
}

export function getBatchStatus (statusCode) {
  return batchStatusMap[String(statusCode)] || { label: `Unknown (${statusCode})`, variant: 'neutral' }
}

const variantColors = {
  error: 'var(--color-danger-500)',
  warning: 'var(--color-warning-500)',
  neutral: 'var(--color-neutral-500)',
  info: 'var(--color-primary-500)',
  success: 'var(--color-success-500)'
}

export function getStatusColor (variant) {
  return variantColors[variant] || variantColors.neutral
}

export const taskStatusFilters = [
  { value: 'all', label: 'All' },
  { value: 'pending', label: 'Pending' },
  { value: 'processing', label: 'Processing' },
  { value: 'complete', label: 'Complete' },
  { value: 'error', label: 'Errors' },
  { value: 'retryable', label: 'Retryable' }
]

export const batchStatusFilters = [
  { key: 'all', value: null, label: 'All' },
  { key: 'running', value: [1], label: 'Running' },
  { key: 'pending', value: [0], label: 'Pending' },
  { key: 'failed', value: [-1, -3], label: 'Failed' },
  { key: 'completed', value: [2], label: 'Completed' },
  { key: 'cancelled', value: [-2], label: 'Cancelled' }
]
